export class StateManager<IState extends Record<string, any>> {
  private _initState: IState;
  private _state: IState;

  constructor(initialState: IState) {
    this._initState = { ...initialState };
    this._state = { ...initialState };
  }

  public setState(state: Partial<IState>, cb?: (state: IState) => any) {
    Object.assign(this._state, state);

    if (cb) {
      cb(this._state);
    }
  }

  public getState() {
    return this._state;
  }

  public resetState() {
    this.setState(this._initState);
  }
}
